import access from '../en/access.js'

export default access
